/**
 * SalonID Testimonials - Bulletproof Infinite Scroll
 * Guaranteed to never stop scrolling
 */
(function() {
  'use strict';

  class InfiniteScroller {
    constructor(column) {
      this.column = column;
      this.isPaused = false;
      this.animationId = null;
      this.scrollPosition = 0;
      this.speed = 0;
      this.contentHeight = 0;
      
      this.init();
    }

    init() {
      // Clone content for seamless loop
      this.cloneContent();
      
      // Wait for layout to be ready
      requestAnimationFrame(() => {
        this.calculateDimensions();
        this.setupGPUAcceleration();
        this.setupHoverEvents();
        this.startAnimation();

        this.observer = new IntersectionObserver((entries) => {
          this.isPaused = !entries[0].isIntersecting;
        }, { rootMargin: '100px' });
        this.observer.observe(this.column);
      });
    }

    cloneContent() {
      // Get all current children
      const children = Array.from(this.column.children);
      
      // Clone them twice for triple buffering (original + 2 clones = 3 sets)
      const fragment = document.createDocumentFragment();
      
      // First clone
      children.forEach(child => {
        fragment.appendChild(child.cloneNode(true));
      });
      
      // Second clone
      children.forEach(child => {
        fragment.appendChild(child.cloneNode(true));
      });
      
      this.column.appendChild(fragment);
    }

    calculateDimensions() {
      // Force layout calculation
      this.column.offsetHeight;
      
      const children = Array.from(this.column.children);
      const totalChildren = children.length;
      
      // Original content is 1/3 of total (since we have original + 2 clones)
      const originalCount = Math.floor(totalChildren / 3);
      
      // Calculate height of original content
      let height = 0;
      const gap = parseFloat(getComputedStyle(this.column).gap) || 0;
      
      for (let i = 0; i < originalCount; i++) {
        height += children[i].getBoundingClientRect().height + gap;
      }
      
      this.contentHeight = height;
      
      // Get speed from data attribute
      const duration = parseFloat(this.column.dataset.duration) || 15;
      
      // Calculate speed (pixels per second)
      this.speed = this.contentHeight / duration;
    }

    setupGPUAcceleration() {
      this.column.style.willChange = 'transform';
      this.column.style.transform = 'translate3d(0, 0, 0)';
    }

    startAnimation() {
      let lastTimestamp = performance.now();
      
      const animate = (currentTimestamp) => {
        // Calculate time elapsed since last frame
        const deltaTime = (currentTimestamp - lastTimestamp) / 1000; // Convert to seconds
        lastTimestamp = currentTimestamp;
        
        if (!this.isPaused) {
          // Update scroll position
          this.scrollPosition += this.speed * deltaTime;
          
          // Reset when we've scrolled past one complete set
          // Use while loop to handle large time gaps
          while (this.scrollPosition >= this.contentHeight) {
            this.scrollPosition -= this.contentHeight;
          }
          
          // Apply transform
          this.column.style.transform = `translate3d(0, -${this.scrollPosition}px, 0)`;
        }
        
        // Continue animation loop
        this.animationId = requestAnimationFrame(animate);
      };
      
      // Start the loop
      this.animationId = requestAnimationFrame(animate);
    }

    setupHoverEvents() {
      this.column.addEventListener('mouseenter', () => {
        this.isPaused = true;
      });

      this.column.addEventListener('mouseleave', () => {
        this.isPaused = false;
      });
    }

    destroy() {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
      if (this.observer) this.observer.disconnect();
    }
  }

  let scrollers = [];

  function initTestimonials() {
    // Clean up existing scrollers
    scrollers.forEach(scroller => scroller.destroy());
    scrollers = [];

    const columns = document.querySelectorAll('.salonid-testimonials__column');
    
    if (columns.length === 0) {
      console.warn('No testimonial columns found');
      return;
    }
    
    columns.forEach(column => {
      const scroller = new InfiniteScroller(column);
      scrollers.push(scroller);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonials);
  } else {
    initTestimonials();
  }

  // Handle Shopify theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      setTimeout(initTestimonials, 100);
    });
    document.addEventListener('shopify:section:reorder', () => {
      setTimeout(initTestimonials, 100);
    });
  }

  // Cleanup on unload
  window.addEventListener('beforeunload', () => {
    scrollers.forEach(scroller => scroller.destroy());
  });
})();